"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { LayoutDashboard } from "lucide-react";
import { Button } from "@/shared/components/ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "@/shared/components/ui/avatar";
import { authClient } from "@/shared/config/authClient.config";
import { getInitials } from "@/shared/lib/utils";
import { NavAuthSkeleton } from "./nav-auth-skeleton";

// Session-aware auth cluster for the desktop marketing nav. Better Auth's
// useSession hook gives us the logged-in state straight on the client.
export const NavAuthButtons = () => {
  const $ = _c(16);
  const {
    data: session,
    isPending
  } = authClient.useSession();
  if (isPending) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <NavAuthSkeleton />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  const user = session?.user;
  if (!user) {
    let t0;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <Button nativeButton={false} variant="ghost" className="hidden h-9 rounded-full px-4 text-sm text-zinc-600 hover:text-zinc-900 md:inline-flex" render={<Link href="/login" />}>Log in</Button>;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <>{t0}<Button nativeButton={false} className="hidden h-9 rounded-full px-4 text-sm md:inline-flex" render={<Link href="/register" />}>Get Started</Button></>;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  const t0 = user.image ?? undefined;
  let t1;
  if ($[3] !== t0 || $[4] !== user.name) {
    t1 = <AvatarImage src={t0} alt={user.name} />;
    $[3] = t0;
    $[4] = user.name;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== user.name) {
    t2 = getInitials(user.name);
    $[6] = user.name;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t2) {
    t3 = <AvatarFallback className="bg-primary/15 text-sm font-bold text-primary">{t2}</AvatarFallback>;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t1 || $[11] !== t3) {
    t4 = <Avatar className="hidden size-9 ring-2 ring-transparent md:flex">{t1}{t3}</Avatar>;
    $[10] = t1;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Button nativeButton={false} className="hidden h-9 rounded-full px-4 text-sm md:inline-flex" render={<Link href="/dashboard" />}>Dashboard</Button>;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t4) {
    t6 = <>{t4}{t5}</>;
    $[14] = t4;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};